import { render, staticRenderFns } from "./bk-bets.vue?vue&type=template&id=2e19e5f0&scoped=true"
import script from "./bk-bets.vue?vue&type=script&lang=js"
export * from "./bk-bets.vue?vue&type=script&lang=js"
import style0 from "./bk-bets.vue?vue&type=style&index=0&id=2e19e5f0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e19e5f0",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/players/player/bk-bets.vue
// module id = w8xz
// module chunks = 0